(function () {
  angular
    .module("akitabox.desktop.workOrder.detail")
    .controller("WorkOrderFloorTabController", WorkOrderFloorTabController);

  /* @ngInject */
  function WorkOrderFloorTabController(
    $timeout,
    building,
    workOrder,
    FloorService,
    ToastService,
    WorkOrderService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.workOrder = workOrder;
    self.floor = null;

    init();

    function init() {
      var floorId = WorkOrderService.getLevel(workOrder)._id;
      FloorService.getById(building._id, floorId)
        .then(function (floor) {
          self.floor = floor;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
